// extracted by mini-css-extract-plugin
module.exports = {"sign":"SplitScreen_sign__2m5Z8","sign__left":"SplitScreen_sign__left__Le34z","sign__right":"SplitScreen_sign__right__IOf7P","sign__content":"SplitScreen_sign__content__2vUIx"};